import { render, staticRenderFns } from "./resultadosExamenProfesional.vue?vue&type=template&id=caca0cfa"
import script from "./resultadosExamenProfesional.vue?vue&type=script&lang=js"
export * from "./resultadosExamenProfesional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports